export const COMMON = 'COMMON';

const INITIAL_STATE = {
    stateData: {
        name: 'Tamil Nadu',
        value: 'TN'
    },
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case COMMON:
            return {
                ...state,
                stateData: action.payload
            };
        default:
            return state;
    }
};